import { render, staticRenderFns } from "./ICP.vue?vue&type=template&id=4d491f85&scoped=true"
import script from "./ICP.vue?vue&type=script&lang=js"
export * from "./ICP.vue?vue&type=script&lang=js"
import style0 from "./ICP.vue?vue&type=style&index=0&id=4d491f85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d491f85",
  null
  
)

export default component.exports